module.exports = __webpack_public_path__ + "static/img/MGI_H5.3bd0149.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/MGI_H5.png
// module id = 6cOK
// module chunks = 34